import { render, staticRenderFns } from "./SWFollowListItem.vue?vue&type=template&id=d7acdcea&scoped=true"
import script from "./SWFollowListItem.vue?vue&type=script&lang=js"
export * from "./SWFollowListItem.vue?vue&type=script&lang=js"
import style0 from "./SWFollowListItem.vue?vue&type=style&index=0&id=d7acdcea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7acdcea",
  null
  
)

export default component.exports